import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Subscription, filter } from 'rxjs';

import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { MonitoringPrecisionClipService, PrecisionResourceType, PrecisionClipProcess } from '../../services/monitoring-precision-clip.service';

@Component({
    selector: 'agpr-precision-clip-loading-dialog',
    templateUrl: './precision-clip-loading-dialog.component.html',
    styleUrl: './precision-clip-loading-dialog.component.scss',
    standalone: false
})
export class PrecisionClipLoadingDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {

    @Input() resourceId: number;
    @Input() resourceType: PrecisionResourceType;

    precisionClipProcess: PrecisionClipProcess;

    protected subscriptions: Subscription[] = [];

    readonly id = 'PrecisionClipLoadingDialog';
    readonly buttonType = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        coreDialogService: CoreDialogService,
        private precisionClipService: MonitoringPrecisionClipService
    ) {
        super(coreDialogService, 'PrecisionClipLoading');
    }

    ngOnInit() {
        this.subscriptions.push(
            this.precisionClipService.watch(this.resourceId, this.resourceType).pipe(filter(x => !!x)).subscribe(process => {
                this.precisionClipProcess = process;

                if (this.precisionClipProcess.status === 'completed') {
                    this.closeDialog();
                }
            })
        );
    }


    dismiss() {
        this.closeDialog();
    }


    cancel() {
        this.closeDialog();
        this.precisionClipService.cancel(this.resourceId, this.resourceType);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
